import React from 'react';
import './index.css';
import CreativeAnimatedStartupForm from './StartUp';

function App() {
  return (
    <div className="App">
      <CreativeAnimatedStartupForm />
    </div>
  );
}

export default App;